import { render, staticRenderFns } from "./withdrawalrecords.vue?vue&type=template&id=2a54d4e0&"
import script from "./withdrawalrecords.vue?vue&type=script&lang=js&"
export * from "./withdrawalrecords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports